module.exports = __webpack_public_path__ + "img/open.8dd844c7.svg";